.chip {
  white-space: nowrap;
  border-radius: var(--border-radius-lg);
  margin-bottom: 16px;
}

.popoverContent {
  position: relative;
  width: max-content;
}
